const FrontDoor = {
    dom: null,
    initialMargin: 0,
    finalMargin: 0,
    maxScroll: 500,
    maxBorderRadius: 0,

    handleScroll() {
        const scrollTop = window.scrollY;
        const progress = Math.min(scrollTop / FrontDoor.maxScroll, 1);
        const currentMargin = FrontDoor.initialMargin + (FrontDoor.finalMargin - FrontDoor.initialMargin) * progress;
        const currentBorderRadius = progress * FrontDoor.maxBorderRadius;

        FrontDoor.dom.style.marginLeft = `${currentMargin}px`;
        FrontDoor.dom.style.marginRight = `${currentMargin}px`;
        FrontDoor.dom.style.borderRadius = `${currentBorderRadius}px`;
    },

    init() {
        const themeElement = document.querySelector(".theme--Codent");
        const frontDoorMedia = document.querySelector('.FrontDoor__media');
        const style = getComputedStyle(themeElement);
        const viewportWidth = window.innerWidth;

        if (themeElement && frontDoorMedia) {
            const container = document.querySelector('.FrontDoor .Container');
            const containerMaxWidth = container.getBoundingClientRect().width;

            FrontDoor.maxBorderRadius = Number.parseFloat(style.getPropertyValue("--radiusLayout")) || 0;
            FrontDoor.finalMargin = (viewportWidth - containerMaxWidth) / 4;
            FrontDoor.dom = frontDoorMedia;

            window.addEventListener('scroll', FrontDoor.handleScroll);
        }
    }
};

export default FrontDoor;
